import { DecimationPolicy } from "./types";

/** Default decimation policy. */
export const DEFAULT_DECIMATION_POLICY: DecimationPolicy = {
  enabled: true,
  points: 2000,
};

/** Default tolerance when comparing visible and loaded range upper bounds (milliseconds). */
export const DEFAULT_RANGE_BOUND_TOLERANCE_MS = 1000;
  